export default {
  name: "Toast"
};